import "./footer.scss";
import Logo from './log.svg';
import Fb from './fb.svg';
import Ig from './ig.svg';
import Tw from './tw.svg';
import Ln from './ln.svg';
import Yt from './yt.svg';
import Chev from "./chev.svg";

const Footer = () => {
    return (
        <div className="footer">
           <img onClick={() => window.scrollTo({ left: 0, top: 0, behavior: "smooth" })} className="chev" src={Chev} alt="chev" />
            

            <div className="left">
                <div className="top">
                    <p className="name">Fifthwall<br />(FWA Marketing Limited)</p>
                </div>
                <div className="middle">
                    <p className="tit">Lagos</p>
                    <p className="add">No. 7-11 Obagun Avenue, off Fatai <br />Atere Way, Matori Industrial Estate.</p>
                </div>
                <div className="bottom">
                    <p className="tit">Telephone</p>
                    {/* <p className="phone">+234 (0) 810 904 1169</p> */}
                    <a className="phone" href="tel:5554280940">+234 (0) 810 904 1169</a>
                </div>
            </div>
            <div className="middle xc">
                <div className="top">
                    <p className="bold">Want to partner <br /> with us?</p>
                </div>
                <div className="middle">
                    <p className="tit">London</p>
                    <p className="add">WEM Tower, 1 Harrow Road, Wembley, <br /> London, HA9 6FA.</p>
                </div>
                <div className="bottom">
                    <p className="tit">General Inquiries</p>
                    <a href="mailto:contact@fifthwallagency.com" className="phone">contact@fifthwallagency.com</a>
                </div>
            </div>
            <div className="right cx">
                <div className="top">
                    <img src={Logo} alt="fifthway logo" />
                </div>
                <div className="middle">
                    <a href="https://www.instagram.com/fifthwallng" target="_blank"><img src={Ig} alt="ig" /></a>
                    <a href="https://twitter.com/fifthwallng" target="_blank"><img src={Tw} alt="tw" /></a>
                    <a href="https://www.linkedin.com/company/fifthwall-agency" target="_blank"><img src={Ln} alt="ln" /></a>
                    <a href="https://www.youtube.com/channel/UCnR-yRp0He_YbHm5waS4K1A" target="_blank"><img src={Yt} alt="yt" /></a>
                </div>
                <div className="bottom">
                    <p className="small">©{(new Date()).getFullYear()} FWA Marketing Limited</p>
                </div>
            </div>
        </div>
    )
}

export default Footer;